<template>
  <div class="main">
    <div class="email-transaction-list">
      <h1 class="title">Email Transactions</h1>
      <div class="row">
        <div class="container">
          <!-- Form for filtering email transactions -->
          <div class="form-group">
            <label for="party">Party</label>
            <select id="party" v-model="partyid" >
              <option value="0">Select Party</option>
              <option v-for="party in party" :key="party.autoid" :value="party.autoid">
                {{ party.short_name }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <label for="fromdate">From Date *</label>
            <input type="text" id="fromdate" v-model="formData.from_date" placeholder="DD/MM/YYYY" />
          </div>
          <div class="form-group">
            <label for="todate">To Date *</label>
            <input type="text" id="todate" v-model="formData.to_date" placeholder="DD/MM/YYYY" />
          </div>
          <div class="form-group-full">
            <label for="booking_number">Booking Number</label>
            <textarea id="booking_number" v-model="formData.booking_number"
              placeholder="Enter booking number..." rows="3"></textarea>
          </div>
          <div class="form-group-full" style=" display: flex; justify-content: space-between;">
            <div style="margin-right: 10%;">
              <button type="button" class="excel-button" @click="getEmailTransactions" :disabled="isSubmitting">
                Search Transactions
              </button>
              <button type="button" class="cancel-button1" @click="resetForm" :disabled="isSubmitting">
                Reset
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="controls">
        <div class="search-container">
          <input v-model="searchQuery" placeholder="Search..." />
          <i class="fas fa-search search-icon"></i>
        </div>
        <div class="actions">
          <button class="export-button" title="Export to CSV" @click="exportToCSV" :disabled="isSubmitting">
            <i class="fas fa-download"></i>
          </button>
        </div>
      </div>

      <div v-if="isLoading">Loading email transactions...</div>

      <div v-else>
        <div v-if="emailTransactions && emailTransactions.length > 0" class="table-container">
          <table class="transaction-table">
            <thead>
              <tr>
                <th @click="sortByColumn('booking_number')">
                  <span>Booking Number</span>
                  <i class="filter-icon fas fa-sort"></i>
                </th>
                <th @click="sortByColumn('email_address')">
                  <span>From Email</span>
                  <i class="filter-icon fas fa-sort"></i>
                </th>
                <th @click="sortByColumn('email_address')">
                  <span>To Email</span>
                  <i class="filter-icon fas fa-sort"></i>
                </th>
                <th @click="sortByColumn('email_address')">
                  <span>CC Email</span>
                  <i class="filter-icon fas fa-sort"></i>
                </th>
                <th @click="sortByColumn('subject')">
                  <span>Subject</span>
                  <i class="filter-icon fas fa-sort"></i>
                </th>
                <th @click="sortByColumn('created_date')">
                  <span>Created Date</span>
                  <i class="filter-icon fas fa-sort"></i>
                </th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="transaction in paginatedTransactions" :key="transaction.id">
                <td>{{ transaction.booking_number }}</td>
                <td class="ellipsis-long" @click="copyText(transaction.sender_email)">{{ transaction.sender_email }}
                </td>
                <td class="ellipsis-long" @click="copyText(transaction.to_emails)">{{ transaction.to_emails }}</td>
                <td class="ellipsis-long" @click="copyText(transaction.cc_emails)">{{ transaction.cc_emails }}</td>
                <td class="ellipsis-long" @click="copyText(transaction.subject)">{{ transaction.subject }}</td>
                <td>{{ formatDate(transaction.created_at) }}</td>
                <td>
                  <button @click="viewEmailDetails(transaction)" class="view-button" :disabled="isSubmitting">
                    <i class="fas fa-eye"></i> View
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-else-if="!isLoading" class="no-data">
          <p>No email transactions found. Please adjust your search criteria.</p>
        </div>

        <div v-if="emailTransactions && emailTransactions.length > 0" class="bottom-controls">
          <div class="rows-per-table">
            <span>Rows per page:</span>
            <button v-for="option in [10, 20, 30, 50]" :key="option" :class="{ 'active': rowsPerPage === option }"
              @click="setRowsPerPage(option)">
              {{ option }}
            </button>
          </div>
          <div class="pagination">
            <button @click="goToPage(currentPage - 1)" :disabled="currentPage <= 1" class="page-nav">
              &lt;
            </button>
            <button v-for="page in paginatedPages" :key="page" @click="goToPage(page)"
              :class="{ 'active': currentPage === page }" class="page-number">
              {{ page }}
            </button>
            <button @click="goToPage(currentPage + 1)" :disabled="currentPage >= totalPages" class="page-nav">
              &gt;
            </button>
          </div>
        </div>

        <!-- Email Details Modal -->
        <div v-if="isModalVisible" class="email-overlay">
          <div class="email-overlay-content">
            <span class="close-btn" @click="closeModal">&times;</span>
            <h2>Email Transaction Details</h2>
            <div v-if="selectedTransaction" class="email-details">
              <div class="detail-row">
                <label>Booking Number:</label>
                <span>{{ selectedTransaction.booking_number }}</span>
              </div>
              <div class="detail-row">
                <label>From :</label>
                <span>{{ selectedTransaction.sender_email }}</span>
              </div>
              <div class="detail-row">
                <label>To :</label>
                <span class="wraptext">{{ selectedTransaction.to_emails }}</span>
              </div>
              <div class="detail-row">
                <label>CC :</label>
                <span class="wraptext">{{ selectedTransaction.cc_emails }}</span>
              </div>
              <div class="detail-row">
                <label>Subject:</label>
                <span class="wraptext">{{ selectedTransaction.subject }}</span>
              </div>
              <div class="detail-row">
                <label>Created Date:</label>
                <span>{{ formatDate(selectedTransaction.created_at) }}</span>
              </div>
            </div>
            <div class="form-buttons">
              <button type="button" class="cancel-button" @click="closeModal" :disabled="isSubmitting">
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { useToast } from 'vue-toastification';
import * as cs from '../assets/js/commonscript.js'

export default {
  name: 'EmailTransactionPage',
  data() {
    return {
      emailTransactions: [],
      isLoading: false,
      isSubmitting: false,
      searchQuery: '',
      rowsPerPage: 20,
      currentPage: 1,
      party: JSON.parse(localStorage.getItem('party')) || [],
      partyid: 0,      
      formData: {
        applicantid: 0,
        accountid: 0,
        booking_number: '',
        from_date: '',
        to_date: ''
      },
      sortDirection: {
        id: 'desc',
        booking_number: 'asc',
        email_address: 'asc',
        subject: 'asc',
        status: 'asc',
        sent_date: 'desc',
        created_date: 'desc'
      },
      isModalVisible: false,
      selectedTransaction: null
    };
  },
  computed: {
    filteredTransactions() {
      if (!this.emailTransactions) {
        return [];
      }
      return this.emailTransactions.filter(transaction => {
        return Object.values(transaction).some(value =>
          String(value).toLowerCase().includes(this.searchQuery.toLowerCase())
        );
      }).sort((a, b) => {
        for (const key in this.sortDirection) {
          if (a[key] < b[key]) return this.sortDirection[key] === 'asc' ? -1 : 1;
          if (a[key] > b[key]) return this.sortDirection[key] === 'asc' ? 1 : -1;
        }
        return 0;
      });
    },
    paginatedTransactions() {
      if (!this.filteredTransactions) {
        return [];
      }
      const start = (this.currentPage - 1) * this.rowsPerPage;
      const end = start + this.rowsPerPage;
      return this.filteredTransactions.slice(start, end);
    },
    totalPages() {
      if (!this.filteredTransactions) {
        return 0;
      }
      return Math.ceil(this.filteredTransactions.length / this.rowsPerPage);
    },
    paginatedPages() {
      const totalPages = this.totalPages;
      const currentPage = this.currentPage;
      const maxPagesToShow = 10;
      let pages = [];

      if (totalPages <= maxPagesToShow) {
        pages = Array.from({ length: totalPages }, (_, i) => i + 1);
      } else {
        pages.push(1);

        let start = Math.max(2, currentPage - 4);
        let end = Math.min(totalPages - 1, currentPage + 4);

        if (start > 2) {
          pages.push('...');
        }

        for (let i = start; i <= end; i++) {
          pages.push(i);
        }

        if (end < totalPages - 1) {
          pages.push('...');
        }

        if (totalPages > 1) {
          pages.push(totalPages);
        }
      }

      return pages;
    }
  },
  methods: {
    copyText(text) {
      navigator.clipboard.writeText(text);
      //alert("Copied: " + text); // optional feedback
      useToast().success("Copied: " + text);
    },
    updateApplicantAccountIds(value) {
      const AppAcc = cs.GetAppAccFromParty(value)
      this.formData.applicantid = AppAcc.applicantid
      this.formData.accountid = AppAcc.accountid
    },
    async getEmailTransactions() {
      if (this.isSubmitting) return;
      const toast = useToast();
      this.isSubmitting = true;
      this.isLoading = true;
      this.formData.applicantid = 0
      this.formData.accountid = 0
      try {
        const token = localStorage.getItem('access_token');
        if (!token) {
          toast.error('Authentication token not found.');
          return;
        }

        const config = {
          headers: {
            'accept': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        };
        if(this.partyid != 0){
          this.updateApplicantAccountIds(this.partyid)
        }
        var fromDt = ''
        var toDt = ''
        var booking_number = ''
        if (this.formData.from_date != '') {
          fromDt = cs.ConvertToISODate(this.formData.from_date)
        }
        if (this.formData.to_date != '') {
          toDt = cs.ConvertToISODate(this.formData.to_date)
        }
        if (this.formData.booking_number.trim()) {
          booking_number = this.formData.booking_number.trim()
        }
        // Build query parameters
        const params = new URLSearchParams({
          applicantid: this.formData.applicantid,
          accountid: this.formData.accountid,
          from_date: fromDt,
          to_date: toDt,
          booking_number: booking_number
        });

        const response = await axios.get(`/getemailtransactions?${params.toString()}`, config);
        console.log(response)
        // Handle different response structures
        if (response.data && Array.isArray(response.data)) {
          this.emailTransactions = response.data[2];
        } else {
          this.emailTransactions = [];
        }

        this.currentPage = 1; // Reset to first page
        toast.success(`Found ${this.emailTransactions.length} email transactions.`);
      } catch (error) {
        console.error('Error fetching email transactions:', error);
        this.emailTransactions = [];
        toast.error(error.response?.data?.message || 'Error fetching email transactions.');
      } finally {
        this.isLoading = false;
        this.isSubmitting = false;
      }
    },

    async resendEmail(transaction) {
      if (this.isSubmitting) return;

      const toast = useToast();
      this.isSubmitting = true;

      try {
        const token = localStorage.getItem('access_token');
        if (!token) {
          toast.error('Authentication token not found.');
          return;
        }

        const config = {
          headers: {
            'accept': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        };

        // You may need to adjust this endpoint based on your API
        const response = await axios.post(`/resendemail/${transaction.id}`, {}, config);
        console.log(response)
        toast.success('Email resent successfully.');
        this.getEmailTransactions(); // Refresh the list
      } catch (error) {
        console.error('Error resending email:', error);
        toast.error(error.response?.data?.message || 'Error resending email.');
      } finally {
        this.isSubmitting = false;
      }
    },

    viewEmailDetails(transaction) {
      if (this.isSubmitting) return;

      this.selectedTransaction = transaction;
      this.isModalVisible = true;
    },

    closeModal() {
      if (this.isSubmitting) return;

      this.isModalVisible = false;
      this.selectedTransaction = null;
    },

    exportToCSV() {
      if (this.isSubmitting) return;

      if (!this.filteredTransactions || this.filteredTransactions.length === 0) {
        useToast().error('No data to export.');
        return;
      }

      try {
        const headers = [
          "ID", "Booking Number", "Email Address", "Subject", "Status", "Sent Date", "Created Date"
        ];

        const csvContent = [
          headers.join(","),
          ...this.filteredTransactions.map(transaction =>
            [
              transaction.id,
              transaction.booking_number || '',
              transaction.email_address || '',
              `"${(transaction.subject || '').replace(/"/g, '""')}"`,
              transaction.status || '',
              this.formatDate(transaction.sent_date),
              this.formatDate(transaction.created_date)
            ].join(",")
          )
        ].join("\n");

        const encodedUri = encodeURI("data:text/csv;charset=utf-8," + csvContent);
        const link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", `email_transactions_${new Date().toISOString().split('T')[0]}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        useToast().success('CSV exported successfully!');
      } catch (error) {
        console.error('Error exporting CSV:', error);
        useToast().error('Error exporting CSV.');
      }
    },

    resetForm() {
      if (this.isSubmitting) return;

      this.formData = {
        booking_number: '',
        from_date: '',
        to_date: ''
      };
      this.emailTransactions = [];
      this.currentPage = 1;
      this.searchQuery = '';
      useToast().success('Form reset successfully!');
    },

    setRowsPerPage(option) {
      this.rowsPerPage = option;
      this.currentPage = 1;
    },

    goToPage(page) {
      if (page === '...' || page === this.currentPage) return;
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },

    sortByColumn(column) {
      this.sortDirection[column] = this.sortDirection[column] === 'asc' ? 'desc' : 'asc';
    },

    formatDate(dateString) {
      if (!dateString) return 'N/A';

      try {
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return 'Invalid Date';

        const day = ('0' + date.getDate()).slice(-2);
        const month = ('0' + (date.getMonth() + 1)).slice(-2);
        const year = date.getFullYear();
        const hours = ('0' + date.getHours()).slice(-2);
        const minutes = ('0' + date.getMinutes()).slice(-2);

        return `${day}/${month}/${year} ${hours}:${minutes}`;
      } catch (error) {
        return 'Invalid Date';
      }
    },

    getStatusClass(status) {
      switch (status?.toLowerCase()) {
        case 'sent':
        case 'delivered':
          return 'status-success';
        case 'failed':
        case 'error':
          return 'status-error';
        case 'pending':
        case 'queued':
          return 'status-pending';
        default:
          return 'status-default';
      }
    }
  }
};
</script>

<style scoped>
.ellipsis-long {
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}
.wraptext{
  max-width: 590px;
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
  cursor: pointer;
}
.main {
  background-color: #f0f2f5;
  font-family: 'Roboto', sans-serif;
  min-height: 100vh;
}

.email-transaction-list {
  padding: 20px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-size: 14px;
  color: #333;
}

.title {
  color: #2c3e50;
  margin-bottom: 20px;
  font-size: 24px;
  font-weight: 600;
}

.row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}

.container {
  width: 100%;
  background: #fff;
  padding: 20px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  margin-bottom: 20px;
}

.form-group {
  margin-bottom: 15px;
  width: 22%;
  padding: 5px;
  float: left;
}
.form-group-full {
  margin-bottom: 15px;
  width: 100%;
  padding: 5px;
  float: left;
}

label {
  display: block;
  margin-bottom: 5px;
  font-weight: 500;
  color: #555;
}

input[type="text"],
input[type="date"],
select,
textarea {
  width: 90%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  font-family: inherit;
  resize: vertical;
}

input::placeholder {
  color: #888;
}

.excel-button,
.cancel-button1 {
  background-color: #28a745;
  color: white;
  border: none;
  padding: 10px 15px;
  border-radius: 5px;
  cursor: pointer;
  margin-right: 10px;
  font-size: 14px;
  transition: background-color 0.3s ease;
}

.cancel-button1 {
  background-color: #dc3545;
}

.excel-button:hover {
  background-color: #218838;
}

.cancel-button1:hover {
  background-color: #c82333;
}

.excel-button:disabled,
.cancel-button1:disabled,
.export-button:disabled,
.view-button:disabled,
.resend-button:disabled,
.cancel-button:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
  opacity: 0.6;
}

.controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  background: white;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.search-container {
  position: relative;
}

.search-container input {
  padding: 8px 30px 8px 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  width: 250px;
}

.search-icon {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  color: #666;
  cursor: pointer;
}

.actions {
  display: flex;
  align-items: center;
}

.export-button {
  background-color: #17a2b8;
  color: white;
  border: none;
  padding: 8px 12px;
  cursor: pointer;
  font-size: 14px;
  border-radius: 4px;
  transition: background-color 0.3s ease;
}

.export-button:hover {
  background-color: #138496;
}

.table-container {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  max-height: 600px;
  overflow-y: auto;
}

.transaction-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.transaction-table th,
.transaction-table td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

.transaction-table th {
  background-color: #f8f9fa;
  font-weight: 600;
  cursor: pointer;
  user-select: none;
  position: sticky;
  top: 0;
  z-index: 10;
}

.transaction-table th:hover {
  background-color: #e9ecef;
}

.filter-icon {
  margin-left: 5px;
  opacity: 0.6;
}

.transaction-table tr:hover {
  background-color: #f8f9fa;
}

.status-success {
  color: #28a745;
  font-weight: 600;
}

.status-error {
  color: #dc3545;
  font-weight: 600;
}

.status-pending {
  color: #ffc107;
  font-weight: 600;
}

.status-default {
  color: #6c757d;
  font-weight: 600;
}

.view-button,
.resend-button {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 5px 10px;
  border-radius: 3px;
  cursor: pointer;
  font-size: 12px;
  margin-right: 5px;
  transition: background-color 0.3s ease;
}

.resend-button {
  background-color: #28a745;
}

.view-button:hover {
  background-color: #0056b3;
}

.resend-button:hover {
  background-color: #218838;
}

.no-data {
  text-align: center;
  padding: 40px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  color: #666;
  font-size: 16px;
}

.bottom-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  background: white;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.rows-per-table {
  display: flex;
  align-items: center;
}

.rows-per-table span {
  margin-right: 10px;
  font-weight: 500;
}

.rows-per-table button {
  width: 35px;
  height: 35px;
  border: 1px solid #ddd;
  background-color: #fff;
  color: #333;
  font-size: 14px;
  border-radius: 4px;
  margin-left: 5px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.rows-per-table button.active,
.rows-per-table button:hover {
  background-color: #007bff;
  color: white;
  border-color: #007bff;
}

.pagination {
  display: flex;
  align-items: center;
}

.page-nav,
.page-number {
  border: 1px solid #ddd;
  background-color: #fff;
  color: #333;
  padding: 8px 12px;
  margin: 0 2px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s ease;
}

.page-nav:disabled {
  background-color: #f8f9fa;
  color: #6c757d;
  cursor: not-allowed;
}

.page-number.active,
.page-nav:hover:not(:disabled),
.page-number:hover {
  background-color: #007bff;
  color: white;
  border-color: #007bff;
}

/* Email Details Modal */
.email-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: auto;
  z-index: 9999;
}

.email-overlay-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 90%;
  max-width: 800px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  position: relative;
}

.close-btn {
  position: absolute;
  top: 15px;
  right: 20px;
  font-size: 24px;
  cursor: pointer;
  color: #333;
  background: none;
  border: none;
}

.close-btn:hover {
  color: #dc3545;
}

.email-details {
  margin-top: 20px;
}

.detail-row {
  display: flex;
  margin-bottom: 15px;
  align-items: flex-start;
}

.detail-row label {
  font-weight: 600;
  min-width: 120px;
  margin-right: 15px;
  color: #555;
}

.detail-row span {
  flex: 1;
}

.email-body {
  flex-direction: column;
}

.email-body label {
  margin-bottom: 10px;
}

.email-content {
  border: 1px solid #ddd;
  padding: 15px;
  border-radius: 4px;
  background-color: #f8f9fa;
  max-height: 300px;
  overflow-y: auto;
}

.error-text {
  color: #dc3545;
  font-style: italic;
}

.form-buttons {
  margin-top: 20px;
  text-align: center;
}

.cancel-button {
  background-color: #6c757d;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
}

.cancel-button:hover {
  background-color: #545b62;
}

/* Clear floats */
.row:after {
  content: "";
  display: table;
  clear: both;
}

/* Responsive design */
@media (max-width: 768px) {
  .form-group {
    width: 100%;
    float: none;
  }

  .controls {
    flex-direction: column;
    gap: 15px;
  }

  .search-container input {
    width: 100%;
  }

  .bottom-controls {
    flex-direction: column;
    gap: 15px;
  }
}
</style>